(function () {
  'use strict';

  // Home v2 hero: cycles the purple word in the heading. Only classes change
  // — the first word stays the one exposed to assistive tech, and the CSS
  // keeps the rotator as wide as its longest word, so the heading never
  // reflows (see the snippet).

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function initRotator(el) {
    if (el._heroRotatorInit) return;
    el._heroRotatorInit = true;

    var words = el.querySelectorAll('.hero__rotator-word');
    if (words.length < 2) return;

    var interval = parseInt(el.getAttribute('data-interval'), 10) || 2500;
    var index = 0;
    var timer = null;

    function tick() {
      // The Theme Editor swaps the section markup; a detached rotator must
      // not keep its timer alive.
      if (!el.isConnected) {
        stop();
        return;
      }

      var current = words[index];
      index = (index + 1) % words.length;
      var next = words[index];

      words.forEach(function (word) {
        word.classList.remove('is-leaving');
      });
      current.classList.remove('is-active');
      current.classList.add('is-leaving');
      next.classList.add('is-active');
    }

    function start() {
      if (timer || reduceMotion.matches || document.hidden) return;
      timer = window.setInterval(tick, interval);
    }

    function stop() {
      window.clearInterval(timer);
      timer = null;
    }

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stop();
      else start();
    });

    reduceMotion.addEventListener('change', function () {
      if (reduceMotion.matches) stop();
      else start();
    });

    start();
  }

  function init(root) {
    (root || document).querySelectorAll('[data-hero-rotator]').forEach(initRotator);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
    });
  } else {
    init();
  }

  // Theme Editor and `shopify theme dev` hot reload replace the section's
  // markup without re-running this file.
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
